module.exports = __webpack_public_path__ + "static/herodesktop-df33ce8e6de84691013665ae33f5a59e.jpg";